import React, { useEffect } from "react";
import { Col, Row } from "reactstrap";
import ActiveLTAValue from "./ActiveLOAValue";
import UNAgencies from "./UNAgencies";
import MDAs from "./MDAs";
import NumberOfLoas from "./NumberOfLoas";
import { getLOASummary } from "common/services/govt-requests.service";
import { setLoaSummary } from "slices/loa/reducer";
import { useDispatch } from "react-redux";

const LOASummaryWidgets = () => {
  const dispatch: any = useDispatch();
  useEffect(() => {
    const fetchLOASummary = async () => {
      try {
        const response: any = await getLOASummary({});
        console.log(response);
        dispatch(setLoaSummary(response));
      } catch (error) {
        console.log(error);
      }
    };
    fetchLOASummary();
  }, [dispatch]);

  return (
    <Row>
      <Col xl={3} md={6}>
        <ActiveLTAValue />
      </Col>
      <Col xl={3} md={6}>
        <UNAgencies />
      </Col>
      <Col xl={3} md={6}>
        <MDAs />
      </Col>
      <Col xl={3} md={6}>
        <NumberOfLoas />
      </Col>
    </Row>
  );
};

export default LOASummaryWidgets;
